/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tag-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M19.523 6.003l-6-5.6a1.5 1.5 0 0 0-2.047 0l-6 5.6A1.499 1.499 0 0 0 5 7.1v16.4A1.5 1.5 0 0 0 6.5 25h12a1.5 1.5 0 0 0 1.5-1.5V7.1a1.499 1.499 0 0 0-.477-1.096zM12.5 10A2.5 2.5 0 1 1 15 7.5a2.5 2.5 0 0 1-2.5 2.5z"/>'
  }
})
